import React, {useEffect} from "react";
import { PayrollClient } from "services";



const SettingsClient = ({setSettings}) => {

  const payrollClient = PayrollClient();
  
  useEffect(() => {
    const fetchData = async () => {
      try {

        const response = await payrollClient.get(`settings/1`);
        const settings = response.data;
        setSettings(settings);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      
    </div>
  )
};


export default SettingsClient;
